import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {provide} from 'vue';
import TheNotaioLayout from "../layouts/TheNotaioLayout.vue";
import {useComponent} from "fallco-frontend-framework/src/vue/composable/useComponent";
import {useDesignSystem} from "../composable/useDesignSystem";
import TheDevSidebar from "../design_system/TheDevSidebar.vue";


export default {
  __name: 'ThePageLayout',
  props: {
  /**
   * dati dell'utente connesso
   */
  dati: {
    type: [Object, Array],
    default() {
      return {}
    }
  },
  /**
   * Dati inerenti l'intestazione
   * @example {path: '...'}
   */
  intestazione: {
    type: Object,
    default() {
      return {}
    }
  },
  title: {
    type: String,
    default: ''
  }
},
  setup(__props) {

/**
 * @doc Descrive il layout di base
 */
const props = __props

const {design_colors} = useDesignSystem();
const {is_mobile_view} = useComponent();

/**
 * @provides {isMobile} per verificare se siamo nel mobile
 */
provide('isMobile', is_mobile_view)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheNotaioLayout, {
      dati: __props.dati,
      intestazione: __props.intestazione
    }, {
      "intestazione-toolbar": _withCtx(() => [
        _createCommentVNode(" @slot permette di inserire una toolbar affianco al titolo "),
        _renderSlot(_ctx.$slots, "intestazione-toolbar")
      ]),
      "intestazione-sottotitolo": _withCtx(() => [
        _createCommentVNode(" @slot permette di inserire un sottotitolo alla sezione "),
        _renderSlot(_ctx.$slots, "intestazione-sottotitolo")
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["dati", "intestazione"]),
    _createVNode(TheDevSidebar)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}